// import { ListViewProvider } from '../core/ListViewProvider'
// import { QueryRequestProvider } from '../core/QueryRequestProvider'
// import { QueryResponseProvider } from '../core/QueryResponseProvider'
// import { useState } from 'react'
// import { useAuth } from '../../../../auth'

// const initialState = {
//     batchId: '',
//     transactionType: '',
// }

// const QualityList = () => {
//     const [userSelectedData, setUserSelectedData] = useState<any>(initialState)
//     const [searchResult, setSearchResult] = useState(false)
//     const { isFacilityManager, auth }: any = useAuth()

//     const transactionTypeOptions = [
//         { label: 'Material Inward', value: 'MATERIAL_INWARD' },
//         { label: 'Processing', value: 'PROCESSING' },
//         { label: 'Material Transfer', value: 'MATERIAL_TRANSFER' },
//         { label: 'External Sale', value: 'EXTERNAL_SALE' },
//     ]

//     const handleChange = (name, value) => {
//         setSearchResult(false)
//         setUserSelectedData({ ...userSelectedData, [name]: value })
//     }

//     const getAuthToken = () => {
//         const authData = localStorage.getItem('kt-auth-react-v');
//         if (authData) {
//             const parsedData = JSON.parse(authData);
//             return parsedData.data?.token;
//         }
//         return null;
//     }

//     const callAnalyzeImageApi = async () => {
//         try {

//             const getOrderEndpoint = (transactionType) => {
//                 switch (transactionType) {
//                     case 'MATERIAL_INWARD': return 'collect/orders';
//                     case 'PROCESSING': return 'productions';
//                     case 'MATERIAL_TRANSFER': return 'return/orders';
//                     case 'EXTERNAL_SALE': return 'convert/orders';
//                     default: return '';
//                 }
//             };

//             const token = getAuthToken();
//             const orderEndpoint = getOrderEndpoint(userSelectedData.transactionType);
//             const orderResponse = await fetch(
//                 `${process.env.REACT_APP_BASE_API_URL}${orderEndpoint}/${userSelectedData.batchId}`,
//                 {
//                     headers: {
//                         'Authorization': `Bearer ${token}`,
//                         'Content-Type': 'application/json'
//                     }
//                 }
//             );

//             const orderData = await orderResponse.json();
//             // console.log('Order details API Response:', orderData);

//             // Get images from the order response
//             const images = orderData.data?.[0]?.images || [];

//             // First API call - analyzeImage (for each image)
//             if (images.length > 0) {
//                 for (let i = 0; i < images.length; i++) {
//                     const imageUrl = images[i];
//                     console.log(`Analyzing image ${i + 1}/${images.length}:`, imageUrl);

//                     const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}analyzeImage`, {
//                         method: 'POST',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify({
//                             imageUrl: imageUrl,
//                             prompt: "Plastic Presence: Is there any plastic visible in the image?(yes/no) If yes,Specify the plastic types between PET HDPE LDPE PP MLP PS and PVC, also Identify Place if can , Respond in conclusion only ",
//                             model: "gpt-4.1",
//                             orderId: userSelectedData.batchId
//                         })
//                     });

//                     const data = await response.json();
//                     console.log(`API Response for image ${i + 1}:`, data);
//                 }
//             } else {
//                 console.log('No images found in order data');
//             }

//             // Second API call - trace
//             const getOrderType = (transactionType) => {
//                 switch (transactionType) {
//                     case 'MATERIAL_INWARD': return 'COLLECT';
//                     case 'PROCESSING': return 'PRODUCTION';
//                     case 'MATERIAL_TRANSFER': return 'RETURN';
//                     case 'EXTERNAL_SALE': return 'CONVERT';
//                     default: return '';
//                 }
//             };

//             const orderType = getOrderType(userSelectedData.transactionType);
//             const traceResponse = await fetch(
//                 `${process.env.REACT_APP_BASE_API_URL?.replace('/v1', '') || ''}trace/${userSelectedData.batchId}?orderType=${orderType}`
//             );

//             const traceData = await traceResponse.json();
//             console.log('Trace API Response:', traceData);

//         } catch (error) {
//             console.error('Error calling APIs:', error);
//         }
//     }

//     const finalProductCards = [
//         {
//             title: 'Final Product Sale',
//             batchId: 'BATCH-2025-001',
//             weight: '150 KG',
//             category: 'PET Bottles',
//             item: 'Recycled Pellets',
//             facility: 'Green Recycling Center',
//             address: '123 Industrial Street, Sector 5',
//             country: 'Philippines',
//         },
//         {
//             title: 'Final Product Sale',
//             batchId: 'BATCH-2025-002',
//             weight: '200 KG',
//             category: 'HDPE Plastics',
//             item: 'Granules',
//             facility: 'Eco Plastics Hub',
//             address: '456 Green Road, Sector 8',
//             country: 'India',
//         },
//         {
//             title: 'Final Product Sale',
//             batchId: 'BATCH-2025-003',
//             weight: '180 KG',
//             category: 'Polypropylene',
//             item: 'Flakes',
//             facility: 'Plastic Renew Plant',
//             address: '789 Recycling Lane, Zone 2',
//             country: 'Vietnam',
//         },
//     ]

//     return (
//         <>
//             <div className="card mb-3">
//                 <div className="card-body">
//                     {/* Input Fields Top */}
//                     <div style={{ display: 'flex', gap: '24px', marginBottom: '24px', flexWrap: 'wrap' }}>
//                         <div>
//                             <label className='form-label fs-6 fw-bold'>Enter Batch id</label>
//                             <input
//                                 type="text"
//                                 placeholder="Enter Batch id"
//                                 value={userSelectedData.batchId}
//                                 onChange={(e) => handleChange('batchId', e.target.value)}
//                                 className='form-control form-control-solid w-250px'
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                             />
//                         </div>

//                         <div>
//                             <label className='form-label fs-6 fw-bold'>Transaction type</label>
//                             <select
//                                 value={userSelectedData.transactionType}
//                                 onChange={(e) => handleChange('transactionType', e.target.value)}
//                                 className='form-control form-control-solid w-250px'
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                             >
//                                 <option value="">Select Transaction type</option>
//                                 {transactionTypeOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className='flex items-end'>
//                             <button
//                                 type='button'
//                                 style={{ backgroundColor: '#12B886' }}
//                                 onClick={() => {
//                                     setSearchResult(true)
//                                     callAnalyzeImageApi()
//                                 }}
//                                 className='btn btn-primary fw-bold px-6'
//                                 disabled={!userSelectedData.batchId || !userSelectedData.transactionType}
//                             >
//                                 Apply
//                             </button>
//                         </div>
//                     </div>

//                     {/* Final Product Sale Cards Side by Side */}
//                     <div style={{
//                         display: 'flex',
//                         flexDirection: 'row',
//                         gap: '20px',
//                         marginTop: '24px',
//                         justifyContent: 'flex-start',
//                         alignItems: 'stretch'
//                     }}>
//                         {finalProductCards.map((card, idx) => (
//                             <div key={idx} style={{
//                                 flex: '1 1 0',
//                                 minWidth: '280px',
//                                 maxWidth: '340px',
//                                 border: '1px solid #e0e0e0',
//                                 borderRadius: '8px',
//                                 backgroundColor: 'white',
//                                 boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
//                                 overflow: 'hidden',
//                                 display: 'flex',
//                                 flexDirection: 'column'
//                             }}>
//                                 {/* Header */}
//                                 <div style={{
//                                     backgroundColor: '#e6f7f7',
//                                     padding: '12px 20px',
//                                     borderBottom: '1px solid #e0e0e0',
//                                 }}>
//                                     <h3 style={{
//                                         margin: 0,
//                                         fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
//                                         fontSize: '16px',
//                                         fontWeight: '600',
//                                         color: '#007a7d'
//                                     }}>
//                                         {card.title}
//                                     </h3>
//                                 </div>

//                                 {/* Content */}
//                                 <div style={{ padding: '20px', display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
//                                     {[
//                                         { label: 'Batch id', value: card.batchId },
//                                         { label: 'Weight', value: card.weight },
//                                         { label: 'Category', value: card.category },
//                                         { label: 'Item', value: card.item },
//                                         { label: 'Facility Name', value: card.facility },
//                                         { label: 'Address', value: card.address },
//                                         { label: 'Country', value: card.country },
//                                     ].map((field, i) => (
//                                         <div key={i}>
//                                             <div style={{ fontSize: '1rem', marginBottom: '8px', color: '#282828' }}>
//                                                 {field.label}
//                                             </div>
//                                             <div style={{
//                                                 backgroundColor: '#f8f8f8',
//                                                 borderRadius: "2px",
//                                                 padding: '6px 12px',
//                                                 display: 'inline-block',
//                                                 fontWeight: 'bold',
//                                                 minWidth: '80px'
//                                             }}>
//                                                 <span style={{ fontSize: '13px', color: '#333' }}>{field.value}</span>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// const InclusiveAiWrapper = () => (
//     <QueryRequestProvider initialValue={{ enabled: false }}>
//         <QueryResponseProvider>
//             <ListViewProvider>
//                 <QualityList />
//             </ListViewProvider>
//         </QueryResponseProvider>
//     </QueryRequestProvider>
// )

// export { InclusiveAiWrapper }





import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { useState } from 'react'
import { useAuth } from '../../../../auth'
import MapComponent from '../Map copy 2'

interface ProductionResponse {
    data: Array<{
        inputMaterial: Array<{
            inputMaterialCategoryName?: string;
            inputMaterialName?: string;
            inputQuantity?: string;
        }>;
        images?: string[];
        pickupPointInfo?: {
            name?: string;
            address?: {
                street?: string;
                state?: string;
                country?: string;
                latitute?: number;
                longitute?: number;
            };
        };
    }>;
}

interface CollectResponse {
    data: Array<{
        orderDetails: Array<{
            categoryName?: string;
            categoryIcon?: string;
            items: Array<{
                itemName?: string;
                itemIcon?: string;
                quantity?: number;
            }>;
        }>;
        centreInfo?: {
            name?: string;
            address?: {
                street?: string;
                state?: string;
                country?: string;
            };
        };
        customerInfo?: {
            name?: string;
            customerType?: string;
            mobile?: string;
            address?: {
                street?: string;
                country?: string;
                city?: string;
                state?: string;
            };
        };
        images?: string[];
    }>;
}





type ApiResponse = ProductionResponse | CollectResponse;

const TRANSACTION_TYPE_OPTIONS = [
    { label: 'Material Inward', value: 'MATERIAL_INWARD' },
    { label: 'Processing', value: 'PROCESSING' },
    { label: 'Material Transfer', value: 'MATERIAL_TRANSFER' },
    { label: 'External Sale', value: 'EXTERNAL_SALE' },
]

const INITIAL_STATE = {
    batchId: '',
    transactionType: '',
}

const QualityList = () => {
    const [userSelectedData, setUserSelectedData] = useState<any>(INITIAL_STATE)
    const [searchResult, setSearchResult] = useState(false)
    const [apiResponse, setApiResponse] = useState<ApiResponse | null>(null)
    const { isFacilityManager, auth }: any = useAuth()
    const [slideDirection, setSlideDirection] = useState<'left' | 'right' | null>(null);

    // Type guard functions
    const isCollectResponse = (response: ApiResponse): response is CollectResponse => {
        return 'orderDetails' in response.data[0];
    }

    const isProductionResponse = (response: ApiResponse): response is ProductionResponse => {
        return 'inputMaterial' in response.data[0];
    }

    // Utility functions
    const getOrderEndpoint = (transactionType: string): string => {
        const endpoints = {
            'MATERIAL_INWARD': 'collect/orders',
            'PROCESSING': 'productions',
            'MATERIAL_TRANSFER': 'return/orders',
            'EXTERNAL_SALE': 'convert/orders',
        };
        return endpoints[transactionType] || '';
    };

    const getOrderType = (transactionType: string): string => {
        const orderTypes = {
            'MATERIAL_INWARD': 'COLLECT',
            'PROCESSING': 'PRODUCTION',
            'MATERIAL_TRANSFER': 'RETURN',
            'EXTERNAL_SALE': 'CONVERT',
        };
        return orderTypes[transactionType] || '';
    };

    const getAuthToken = (): string | null => {
        try {
            const authData = localStorage.getItem('kt-auth-react-v');
            if (authData) {
                const parsedData = JSON.parse(authData);
                return parsedData.data?.token || null;
            }
        } catch (error) {
            // Handle parsing error silently
        }
        return null;
    }

    const handleChange = (name: string, value: string) => {
        setSearchResult(false)
        setUserSelectedData(prev => ({ ...prev, [name]: value.trim() }))
    }

    const analyzeImages = async (images: string[], batchId: string) => {
        if (images.length === 0) return;

        setIsAnalyzing(true);
        const results: any[] = [];

        const analyzePromises = images.map(async (imageUrl, index) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}analyzeImage`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        imageUrl: imageUrl,
                        prompt: "Plastic Presence: Is there any plastic visible in the image?(yes/no) If yes,Specify the plastic types between PET HDPE LDPE PP MLP PS and PVC, also Identify Place if can , Respond in conclusion only ",
                        model: "gpt-4.1",
                        orderId: batchId
                    })
                });
                const data = await response.json();
                results[index] = data;
                return data;
            } catch (error) {
                return null;
            }
        });

        await Promise.allSettled(analyzePromises);
        setAnalysisResults(results.filter(r => r !== null));
        setCurrentAnalysisIndex(0);
        setIsAnalyzing(false);
    }
    const [analysisResults, setAnalysisResults] = useState<any[]>([]);
    const [currentAnalysisIndex, setCurrentAnalysisIndex] = useState(0);
    const [isAnalyzing, setIsAnalyzing] = useState(false);

    const fetchOrderData = async (token: string, endpoint: string, batchId: string) => {
        const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL}${endpoint}/${batchId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return await response.json();
    }

    const fetchTraceData = async (batchId: string, orderType: string) => {
        const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL?.replace('/v1', '') || ''}trace/${batchId}?orderType=${orderType}`
        );
        return await response.json();
    }

    const callAnalyzeImageApi = async () => {
        try {
            const token = getAuthToken();
            if (!token) return;

            const orderEndpoint = getOrderEndpoint(userSelectedData.transactionType);
            if (!orderEndpoint) return;

            // Fetch order data
            const orderData = await fetchOrderData(token, orderEndpoint, userSelectedData.batchId);
            setApiResponse(orderData);

            // Analyze images
            const images = orderData.data?.[0]?.images || [];
            await analyzeImages(images, userSelectedData.batchId);

            // Fetch trace data
            const orderType = getOrderType(userSelectedData.transactionType);
            await fetchTraceData(userSelectedData.batchId, orderType);

        } catch (error) {
            // Handle error silently or show user-friendly message
        }
    }

    const renderIcon = (iconUrl?: string, fallback: string = '📦') => (
        <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'white',
            border: '2px solid #d1d5db',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
        }}>
            {iconUrl ? (
                <img
                    src={iconUrl}
                    alt="Icon"
                    style={{
                        width: '70%',
                        height: '70%',
                        objectFit: 'cover',
                        borderRadius: '50%'
                    }}
                />
            ) : (
                <span style={{ fontSize: '16px', color: '#9ca3af' }}>{fallback}</span>
            )}
        </div>
    );

    const renderMaterialCard = () => {
        if (!apiResponse?.data?.[0]) return null;

        let categoryName, itemName, quantity, categoryIcon, itemIcon;
        let customerName, customerType;

        if (isCollectResponse(apiResponse)) {
            const data = apiResponse.data[0];
            const orderDetail = data.orderDetails[0];
            categoryName = orderDetail?.categoryName;
            categoryIcon = orderDetail?.categoryIcon;
            itemName = orderDetail?.items[0]?.itemName;
            itemIcon = orderDetail?.items[0]?.itemIcon;
            quantity = orderDetail?.items[0]?.quantity;
            customerName = apiResponse.data[0].customerInfo?.name;
            customerType = apiResponse.data[0].customerInfo?.customerType;
        } else if (isProductionResponse(apiResponse)) {
            const data = apiResponse.data[0];
            const inputMaterial = data.inputMaterial?.[0];
            categoryName = inputMaterial?.inputMaterialCategoryName;
            itemName = inputMaterial?.inputMaterialName;
            quantity = inputMaterial?.inputQuantity;
        }

        return (
            <div style={{
                flex: '1 1 0',
                minWidth: '280px',
                maxWidth: '340px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: 'white',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    backgroundColor: '#e6f7f7',
                    padding: '12px 20px',
                    borderBottom: '1px solid #e0e0e0',
                }}>
                    <h3 style={{
                        margin: 0,
                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#007a7d'
                    }}>
                        Material Information
                    </h3>
                </div>

                <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {renderIcon(categoryIcon)}
                        category name
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {categoryName || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ marginBottom: '' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {renderIcon(categoryIcon)}
                            <div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#333',
                                    marginBottom: '4px'
                                }}>
                                    Category
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#666'
                                }}>
                                    {categoryName || 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {renderIcon(itemIcon, '🔧')}
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {itemName || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ marginBottom: '' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {renderIcon(itemIcon, '🔧')}
                            <div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#333',
                                    marginBottom: '4px'
                                }}>
                                    Item
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#666'
                                }}>
                                    {itemName || 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/weight.png"
                                alt="Weight"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {quantity || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ marginBottom: '' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'white',
                                border: '2px solid #d1d5db',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                flexShrink: 0,
                                minWidth: '40px',
                                minHeight: '40px'
                            }}>
                                <img
                                    src="/weight.png"
                                    alt="Weight"
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                            <div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#333',
                                    marginBottom: '4px'
                                }}>
                                    Weight
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#666'
                                }}>
                                    {quantity || 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <span style={{ fontSize: '20px' }}></span>
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {customerName || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ marginBottom: '' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'white',
                                border: '2px solid #d1d5db',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                flexShrink: 0,
                                minWidth: '40px',
                                minHeight: '40px'
                            }}>
                                <span style={{ fontSize: '20px' }}></span>
                            </div>
                            <div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#333',
                                    marginBottom: '4px'
                                }}>
                                    Supplier name
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#666'
                                }}>
                                    {customerName || 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <span style={{ fontSize: '20px' }}></span>
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {customerType || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <span style={{ fontSize: '20px' }}></span>
                        </div>
                        <div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#333',
                                marginBottom: '4px'
                            }}>
                                Supplier type
                            </div>
                            <div style={{
                                fontSize: '13px',
                                color: '#666'
                            }}>
                                {customerType || 'N/A'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderFacilityCard = () => {
        if (!apiResponse?.data?.[0]) return null;

        let facilityInfo;

        if (userSelectedData.transactionType === 'PROCESSING' && isProductionResponse(apiResponse)) {
            facilityInfo = apiResponse.data[0].pickupPointInfo;
        } else if (isCollectResponse(apiResponse)) {
            facilityInfo = apiResponse.data[0].centreInfo;
        } else {
            return null;
        }

        return (
            <div style={{
                flex: '1 1 0',
                minWidth: '280px',
                maxWidth: '340px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: 'white',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    backgroundColor: '#e6f7f7',
                    padding: '12px 20px',
                    borderBottom: '1px solid #e0e0e0',
                }}>
                    <h3 style={{
                        margin: 0,
                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#007a7d'
                    }}>
                        Facility information
                    </h3>
                </div>

                <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/facility name.png"
                                alt="facility"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {facilityInfo?.name || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/facility name.png"
                                alt="facility"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#333',
                                marginBottom: '4px'
                            }}>
                                Business name
                            </div>
                            <div style={{
                                fontSize: '13px',
                                color: '#666'
                            }}>
                                {facilityInfo?.name || 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/street.png"
                                alt="street"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {facilityInfo?.address?.street || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/street.png"
                                alt="street"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#333',
                                marginBottom: '4px'
                            }}>
                                Address
                            </div>
                            <div style={{
                                fontSize: '13px',
                                color: '#666'
                            }}>
                                {facilityInfo?.address?.street || 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/state.png"
                                alt="state"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {facilityInfo?.address?.state || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/state.png"
                                alt="state"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#333',
                                marginBottom: '4px'
                            }}>
                                State/Province
                            </div>
                            <div style={{
                                fontSize: '13px',
                                color: '#666'
                            }}>
                                {facilityInfo?.address?.state || 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/country.png"
                                alt="country"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
                            {facilityInfo?.address?.country || 'N/A'}
                        </span>
                    </div> */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            border: '2px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            minWidth: '40px',
                            minHeight: '40px'
                        }}>
                            <img
                                src="/country.png"
                                alt="country"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                        <div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#333',
                                marginBottom: '4px'
                            }}>
                                Country
                            </div>
                            <div style={{
                                fontSize: '13px',
                                color: '#666'
                            }}>
                                {facilityInfo?.address?.country || 'N/A'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const handlePrevious = () => {
        if (currentAnalysisIndex > 0) {
            setSlideDirection('right');
            setCurrentAnalysisIndex(prev => prev - 1);
            setTimeout(() => {
                setSlideDirection(null);
            }, 300);
        }
    };

    const handleNext = () => {
        if (currentAnalysisIndex < analysisResults.length - 1) {
            setSlideDirection('left');
            setCurrentAnalysisIndex(prev => prev + 1);
            setTimeout(() => {
                setSlideDirection(null);
            }, 300);
        }
    };
    const renderVerificationCard = () => {
        if (!apiResponse?.data?.[0]) return null;

        const images = apiResponse.data[0].images || [];
        if (images.length === 0) return null;

        const currentAnalysis = analysisResults[currentAnalysisIndex];

        const handlePrevious = () => {
            if (currentAnalysisIndex > 0) {
                setSlideDirection('right');
                setTimeout(() => {
                    setCurrentAnalysisIndex(prev => prev - 1);
                    setSlideDirection(null);
                }, 300);
            }
        };

        const handleNext = () => {
            if (currentAnalysisIndex < analysisResults.length - 1) {
                setSlideDirection('left');
                setTimeout(() => {
                    setCurrentAnalysisIndex(prev => prev + 1);
                    setSlideDirection(null);
                }, 300);
            }
        };

        return (
            <div style={{
                flex: '1 1 0',
                minWidth: '400px',
                maxWidth: '500px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: 'white',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    backgroundColor: '#e6f7f7',
                    padding: '12px 20px',
                    borderBottom: '1px solid #e0e0e0',
                }}>
                    <h3 style={{
                        margin: 0,
                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#007a7d'
                    }}>
                        AI Based Material Verification
                    </h3>
                </div>

                <div style={{ padding: '20px', position: 'relative', overflow: 'hidden' }}>
                    <style>{`
                    @keyframes slideInFromRight {
                        from {
                            transform: translateX(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(0);
                            opacity: 1;
                        }
                    }
                    @keyframes slideInFromLeft {
                        from {
                            transform: translateX(-100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(0);
                            opacity: 1;
                        }
                    }
                    @keyframes slideOutToLeft {
                        from {
                            transform: translateX(0);
                            opacity: 1;
                        }
                        to {
                            transform: translateX(-100%);
                            opacity: 0;
                        }
                    }
                    @keyframes slideOutToRight {
                        from {
                            transform: translateX(0);
                            opacity: 1;
                        }
                        to {
                            transform: translateX(100%);
                            opacity: 0;
                        }
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>

                    <div
                        key={currentAnalysisIndex}
                        style={{
                            display: 'flex',
                            gap: '20px',
                            width: '100%',
                            animation: slideDirection === 'left'
                                ? 'slideInFromRight 0.3s ease-out'
                                : slideDirection === 'right'
                                    ? 'slideInFromLeft 0.3s ease-out'
                                    : 'none'
                        }}
                    >
                        {/* Left side - Current Image */}
                        <div style={{
                            flex: '0 0 auto',
                            width: '160px'
                        }}>
                            {images[currentAnalysisIndex] && (
                                <div style={{
                                    width: '160px',
                                    height: '160px',
                                    display: 'block',
                                    cursor: 'pointer'
                                }}
                                    onClick={() => window.open(images[currentAnalysisIndex], '_blank')}
                                >
                                    <img
                                        src={images[currentAnalysisIndex]}
                                        alt={`Material verification ${currentAnalysisIndex + 1}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Right side - Analysis Results or Loading */}
                        <div style={{ flex: '1', minWidth: '200px' }}>
                            {isAnalyzing ? (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '160px',
                                    gap: '12px'
                                }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '4px solid #e0e0e0',
                                        borderTop: '4px solid #007a7d',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }}></div>
                                    <span style={{ fontSize: '14px', color: '#666' }}>
                                        Analyzing images...
                                    </span>
                                </div>
                            ) : currentAnalysis?.data ? (
                                <>
                                    <div style={{ marginBottom: '12px' }}>
                                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                                            Plastic Identified
                                        </div>
                                        <div style={{
                                            fontSize: '13px',
                                            backgroundColor: currentAnalysis.data.plasticPresence?.toLowerCase() === 'yes' ? '#dfffea' : '#ffeef3',
                                            color: currentAnalysis.data.plasticPresence?.toLowerCase() === 'yes' ? '#17c653' : '#f8285a',
                                            padding: '4px 8px',
                                            borderRadius: '6px',
                                            display: 'inline-block',
                                            fontWeight: "bold"
                                        }}>
                                            {currentAnalysis.data.plasticPresence || 'N/A'}
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '12px' }}>
                                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                                            Plastic Type
                                        </div>
                                        <div style={{ fontSize: '13px', color: '#666' }}>
                                            {currentAnalysis.data.kindsOfPlastic || 'N/A'}
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '12px' }}>
                                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                                            Model
                                        </div>
                                        <div style={{ fontSize: '13px', color: '#666' }}>
                                            {currentAnalysis.data.model || 'N/A'}
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>

                    {/* Carousel Controls */}
                    {!isAnalyzing && analysisResults.length > 1 && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '12px',
                            marginTop: '16px',
                            paddingTop: '16px',
                            borderTop: '1px solid #e0e0e0'
                        }}>
                            <button
                                onClick={handlePrevious}
                                disabled={currentAnalysisIndex === 0}
                                style={{
                                    padding: '6px 12px',
                                    backgroundColor: currentAnalysisIndex === 0 ? '#cccccc' : '#007a7d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: currentAnalysisIndex === 0 ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    opacity: currentAnalysisIndex === 0 ? 0.6 : 1
                                }}
                            >
                                ← Previous
                            </button>
                            <span style={{ fontSize: '14px', color: '#666' }}>
                                {currentAnalysisIndex + 1} / {analysisResults.length}
                            </span>
                            <button
                                onClick={handleNext}
                                disabled={currentAnalysisIndex === analysisResults.length - 1}
                                style={{
                                    padding: '6px 12px',
                                    backgroundColor: currentAnalysisIndex === analysisResults.length - 1 ? '#cccccc' : '#007a7d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: currentAnalysisIndex === analysisResults.length - 1 ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    opacity: currentAnalysisIndex === analysisResults.length - 1 ? 0.6 : 1
                                }}
                            >
                                Next →
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const isFormValid = userSelectedData.batchId && userSelectedData.transactionType;

    return (
        <>
            <div className="card mb-3">
                <div className="card-body">
                    {/* Input Fields */}
                    <div style={{ display: 'flex', gap: '24px', marginBottom: '24px', flexWrap: 'wrap' }}>
                        <div>
                            <label className='form-label fs-6 fw-bold'>Enter Batch id</label>
                            <input
                                type="text"
                                placeholder="Enter Batch id"
                                value={userSelectedData.batchId}
                                onChange={(e) => handleChange('batchId', e.target.value)}
                                className='form-control form-control-solid w-250px'
                                style={{
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #dddddd',
                                    color: '#000000',
                                }}
                            />
                        </div>

                        <div>
                            <label className='form-label fs-6 fw-bold'>Transaction type</label>
                            <select
                                value={userSelectedData.transactionType}
                                onChange={(e) => handleChange('transactionType', e.target.value)}
                                className='form-control form-control-solid w-250px'
                                style={{
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #dddddd',
                                    color: '#000000',
                                }}
                            >
                                <option value="">Select Transaction type</option>
                                {TRANSACTION_TYPE_OPTIONS.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className='flex items-end'>
                            <button
                                type='button'
                                style={{ backgroundColor: '#12B886' }}
                                onClick={() => {
                                    setSearchResult(true)
                                    callAnalyzeImageApi()
                                }}
                                className='btn btn-primary fw-bold px-6'
                                disabled={!isFormValid}
                            >
                                Apply
                            </button>
                        </div>
                    </div>

                    {/* Information Cards */}
                    {apiResponse?.data?.[0] && (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '20px',
                            marginTop: '24px',
                            justifyContent: 'flex-start',
                            alignItems: 'stretch'
                        }}>
                            {renderMaterialCard()}
                            {renderFacilityCard()}
                            {renderVerificationCard()}
                        </div>
                    )}
                </div>
            </div>

            {apiResponse?.data?.[0] && <MapComponent data={apiResponse.data} zooms={12} />}
        </>
    )
}

const InclusiveAiWrapper = () => (
    <QueryRequestProvider initialValue={{ enabled: false }}>
        <QueryResponseProvider>
            <ListViewProvider>
                <QualityList />
            </ListViewProvider>
        </QueryResponseProvider>
    </QueryRequestProvider>
)

export { InclusiveAiWrapper }